module.exports = __webpack_public_path__ + "static/media/dashboardSelected.b91fde1d.svg";